/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createSurveyPrefs = /* GraphQL */ `mutation CreateSurveyPrefs(
  $input: CreateSurveyPrefsInput!
  $condition: ModelSurveyPrefsConditionInput
) {
  createSurveyPrefs(input: $input, condition: $condition) {
    id
    version
    studyName
    studySites
    activeSensors
    daysUntilDeactivation
    gameEnabled
    homeScreenEmaAvailable
    studySurveyList {
      random {
        surveyId
        notificationHeader
        notificationBody
        weekdaysAvailable
        totalNumberOfDays
        introStepHeader
        introStepBody
        completionStepEnabled
        completionStepHeader
        completionStepBody
        emaQuestions {
          scale {
            questionId
            questionHeader
            questionBody
            skipEnabled
            minValue
            maxValue
            minimumValueDescription
            maximumValueDescription
            shouldHideRanges
            branchingRule {
              destinationQuestionId
              defaultQuestionId
              minimumExpectedAnswerValue
              maximumExpectedAnswerValue
              __typename
            }
            riskRule {
              alertOnMin
              alertOnMax
              __typename
            }
            __typename
          }
          choice {
            questionId
            questionHeader
            questionBody
            skipEnabled
            multipleChoice
            textChoices {
              textChoiceID
              textToDisplay
              __typename
            }
            branchingRule {
              defaultQuestionId
              destinationQuestionId
              expectedAnswerValues
              destinations {
                choiceId
                destinationQuestionId
                __typename
              }
              __typename
            }
            riskRule {
              alertOn
              __typename
            }
            __typename
          }
          textEntry {
            questionId
            questionHeader
            questionBody
            skipEnabled
            maxCharacterLengthForInput
            textHint
            __typename
          }
          bool {
            questionId
            questionHeader
            questionBody
            skipEnabled
            trueValue
            falseValue
            branchingRule {
              destinationQuestionId
              defaultQuestionId
              expectedAnswer
              __typename
            }
            riskRule {
              alertOn
              __typename
            }
            __typename
          }
          timeOfDay {
            questionId
            questionHeader
            questionBody
            skipEnabled
            defaultHour
            defaultMinute
            branchingRule {
              destinationQuestionId
              defaultQuestionId
              minimumExpectedAnswerHour
              minimumExpectedAnswerMinute
              maximumExpectedAnswerHour
              maximumExpectedAnswerMinute
              __typename
            }
            __typename
          }
          info {
            questionId
            questionHeader
            questionBody
            skipEnabled
            __typename
          }
          __typename
        }
        containsBranchingLogic
        containsShuffledSequence
        containsRiskAlerts
        shuffleSequence {
          startIndex
          endIndex
          __typename
        }
        multipleSurveyBursts
        daysWithinSurveyBurst
        daysBetweenSurveyBursts
        daysBeforeFirstSurveyDelivery
        selfInitiatedSurvey
        weekDeliverySchedule {
          dayOfWeek
          windowStartHour
          windowEndHour
          repeatsEveryDay
          __typename
        }
        __typename
      }
      exact {
        surveyId
        notificationHeader
        notificationBody
        weekdaysAvailable
        totalNumberOfDays
        introStepHeader
        introStepBody
        completionStepEnabled
        completionStepHeader
        completionStepBody
        emaQuestions {
          scale {
            questionId
            questionHeader
            questionBody
            skipEnabled
            minValue
            maxValue
            minimumValueDescription
            maximumValueDescription
            shouldHideRanges
            branchingRule {
              destinationQuestionId
              defaultQuestionId
              minimumExpectedAnswerValue
              maximumExpectedAnswerValue
              __typename
            }
            riskRule {
              alertOnMin
              alertOnMax
              __typename
            }
            __typename
          }
          choice {
            questionId
            questionHeader
            questionBody
            skipEnabled
            multipleChoice
            textChoices {
              textChoiceID
              textToDisplay
              __typename
            }
            branchingRule {
              defaultQuestionId
              destinationQuestionId
              expectedAnswerValues
              destinations {
                choiceId
                destinationQuestionId
                __typename
              }
              __typename
            }
            riskRule {
              alertOn
              __typename
            }
            __typename
          }
          textEntry {
            questionId
            questionHeader
            questionBody
            skipEnabled
            maxCharacterLengthForInput
            textHint
            __typename
          }
          bool {
            questionId
            questionHeader
            questionBody
            skipEnabled
            trueValue
            falseValue
            branchingRule {
              destinationQuestionId
              defaultQuestionId
              expectedAnswer
              __typename
            }
            riskRule {
              alertOn
              __typename
            }
            __typename
          }
          timeOfDay {
            questionId
            questionHeader
            questionBody
            skipEnabled
            defaultHour
            defaultMinute
            branchingRule {
              destinationQuestionId
              defaultQuestionId
              minimumExpectedAnswerHour
              minimumExpectedAnswerMinute
              maximumExpectedAnswerHour
              maximumExpectedAnswerMinute
              __typename
            }
            __typename
          }
          info {
            questionId
            questionHeader
            questionBody
            skipEnabled
            __typename
          }
          __typename
        }
        containsBranchingLogic
        containsShuffledSequence
        containsRiskAlerts
        shuffleSequence {
          startIndex
          endIndex
          __typename
        }
        multipleSurveyBursts
        daysWithinSurveyBurst
        daysBetweenSurveyBursts
        daysBeforeFirstSurveyDelivery
        selfInitiatedSurvey
        weekDeliverySchedule {
          dayOfWeek
          exactDeliveriesForDay {
            surveyDeliveryHour
            surveyDeliveryMinute
            surveyExpirationHour
            surveyExpirationMinute
            repeatsEveryDay
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    maxScreenTimePages
    selfInitiatedSurveyEnabled
    selfInitiatedSurveyTitle
    screenTimeConfig {
      alldays {
        blockId
        start
        end
        __typename
      }
      monday {
        blockId
        start
        end
        __typename
      }
      tuesday {
        blockId
        start
        end
        __typename
      }
      wednesday {
        blockId
        start
        end
        __typename
      }
      thursday {
        blockId
        start
        end
        __typename
      }
      friday {
        blockId
        start
        end
        __typename
      }
      saturday {
        blockId
        start
        end
        __typename
      }
      sunday {
        blockId
        start
        end
        __typename
      }
      __typename
    }
    _version
    _deleted
    _lastChangedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSurveyPrefsMutationVariables,
  APITypes.CreateSurveyPrefsMutation
>;
export const updateSurveyPrefs = /* GraphQL */ `mutation UpdateSurveyPrefs(
  $input: UpdateSurveyPrefsInput!
  $condition: ModelSurveyPrefsConditionInput
) {
  updateSurveyPrefs(input: $input, condition: $condition) {
    id
    version
    studyName
    studySites
    activeSensors
    daysUntilDeactivation
    gameEnabled
    homeScreenEmaAvailable
    studySurveyList {
      random {
        surveyId
        notificationHeader
        notificationBody
        weekdaysAvailable
        totalNumberOfDays
        introStepHeader
        introStepBody
        completionStepEnabled
        completionStepHeader
        completionStepBody
        emaQuestions {
          scale {
            questionId
            questionHeader
            questionBody
            skipEnabled
            minValue
            maxValue
            minimumValueDescription
            maximumValueDescription
            shouldHideRanges
            branchingRule {
              destinationQuestionId
              defaultQuestionId
              minimumExpectedAnswerValue
              maximumExpectedAnswerValue
              __typename
            }
            riskRule {
              alertOnMin
              alertOnMax
              __typename
            }
            __typename
          }
          choice {
            questionId
            questionHeader
            questionBody
            skipEnabled
            multipleChoice
            textChoices {
              textChoiceID
              textToDisplay
              __typename
            }
            branchingRule {
              defaultQuestionId
              destinationQuestionId
              expectedAnswerValues
              destinations {
                choiceId
                destinationQuestionId
                __typename
              }
              __typename
            }
            riskRule {
              alertOn
              __typename
            }
            __typename
          }
          textEntry {
            questionId
            questionHeader
            questionBody
            skipEnabled
            maxCharacterLengthForInput
            textHint
            __typename
          }
          bool {
            questionId
            questionHeader
            questionBody
            skipEnabled
            trueValue
            falseValue
            branchingRule {
              destinationQuestionId
              defaultQuestionId
              expectedAnswer
              __typename
            }
            riskRule {
              alertOn
              __typename
            }
            __typename
          }
          timeOfDay {
            questionId
            questionHeader
            questionBody
            skipEnabled
            defaultHour
            defaultMinute
            branchingRule {
              destinationQuestionId
              defaultQuestionId
              minimumExpectedAnswerHour
              minimumExpectedAnswerMinute
              maximumExpectedAnswerHour
              maximumExpectedAnswerMinute
              __typename
            }
            __typename
          }
          info {
            questionId
            questionHeader
            questionBody
            skipEnabled
            __typename
          }
          __typename
        }
        containsBranchingLogic
        containsShuffledSequence
        containsRiskAlerts
        shuffleSequence {
          startIndex
          endIndex
          __typename
        }
        multipleSurveyBursts
        daysWithinSurveyBurst
        daysBetweenSurveyBursts
        daysBeforeFirstSurveyDelivery
        selfInitiatedSurvey
        weekDeliverySchedule {
          dayOfWeek
          windowStartHour
          windowEndHour
          repeatsEveryDay
          __typename
        }
        __typename
      }
      exact {
        surveyId
        notificationHeader
        notificationBody
        weekdaysAvailable
        totalNumberOfDays
        introStepHeader
        introStepBody
        completionStepEnabled
        completionStepHeader
        completionStepBody
        emaQuestions {
          scale {
            questionId
            questionHeader
            questionBody
            skipEnabled
            minValue
            maxValue
            minimumValueDescription
            maximumValueDescription
            shouldHideRanges
            branchingRule {
              destinationQuestionId
              defaultQuestionId
              minimumExpectedAnswerValue
              maximumExpectedAnswerValue
              __typename
            }
            riskRule {
              alertOnMin
              alertOnMax
              __typename
            }
            __typename
          }
          choice {
            questionId
            questionHeader
            questionBody
            skipEnabled
            multipleChoice
            textChoices {
              textChoiceID
              textToDisplay
              __typename
            }
            branchingRule {
              defaultQuestionId
              destinationQuestionId
              expectedAnswerValues
              destinations {
                choiceId
                destinationQuestionId
                __typename
              }
              __typename
            }
            riskRule {
              alertOn
              __typename
            }
            __typename
          }
          textEntry {
            questionId
            questionHeader
            questionBody
            skipEnabled
            maxCharacterLengthForInput
            textHint
            __typename
          }
          bool {
            questionId
            questionHeader
            questionBody
            skipEnabled
            trueValue
            falseValue
            branchingRule {
              destinationQuestionId
              defaultQuestionId
              expectedAnswer
              __typename
            }
            riskRule {
              alertOn
              __typename
            }
            __typename
          }
          timeOfDay {
            questionId
            questionHeader
            questionBody
            skipEnabled
            defaultHour
            defaultMinute
            branchingRule {
              destinationQuestionId
              defaultQuestionId
              minimumExpectedAnswerHour
              minimumExpectedAnswerMinute
              maximumExpectedAnswerHour
              maximumExpectedAnswerMinute
              __typename
            }
            __typename
          }
          info {
            questionId
            questionHeader
            questionBody
            skipEnabled
            __typename
          }
          __typename
        }
        containsBranchingLogic
        containsShuffledSequence
        containsRiskAlerts
        shuffleSequence {
          startIndex
          endIndex
          __typename
        }
        multipleSurveyBursts
        daysWithinSurveyBurst
        daysBetweenSurveyBursts
        daysBeforeFirstSurveyDelivery
        selfInitiatedSurvey
        weekDeliverySchedule {
          dayOfWeek
          exactDeliveriesForDay {
            surveyDeliveryHour
            surveyDeliveryMinute
            surveyExpirationHour
            surveyExpirationMinute
            repeatsEveryDay
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    maxScreenTimePages
    selfInitiatedSurveyEnabled
    selfInitiatedSurveyTitle
    screenTimeConfig {
      alldays {
        blockId
        start
        end
        __typename
      }
      monday {
        blockId
        start
        end
        __typename
      }
      tuesday {
        blockId
        start
        end
        __typename
      }
      wednesday {
        blockId
        start
        end
        __typename
      }
      thursday {
        blockId
        start
        end
        __typename
      }
      friday {
        blockId
        start
        end
        __typename
      }
      saturday {
        blockId
        start
        end
        __typename
      }
      sunday {
        blockId
        start
        end
        __typename
      }
      __typename
    }
    _version
    _deleted
    _lastChangedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSurveyPrefsMutationVariables,
  APITypes.UpdateSurveyPrefsMutation
>;
export const deleteSurveyPrefs = /* GraphQL */ `mutation DeleteSurveyPrefs(
  $input: DeleteSurveyPrefsInput!
  $condition: ModelSurveyPrefsConditionInput
) {
  deleteSurveyPrefs(input: $input, condition: $condition) {
    id
    version
    studyName
    studySites
    activeSensors
    daysUntilDeactivation
    gameEnabled
    homeScreenEmaAvailable
    studySurveyList {
      random {
        surveyId
        notificationHeader
        notificationBody
        weekdaysAvailable
        totalNumberOfDays
        introStepHeader
        introStepBody
        completionStepEnabled
        completionStepHeader
        completionStepBody
        emaQuestions {
          scale {
            questionId
            questionHeader
            questionBody
            skipEnabled
            minValue
            maxValue
            minimumValueDescription
            maximumValueDescription
            shouldHideRanges
            branchingRule {
              destinationQuestionId
              defaultQuestionId
              minimumExpectedAnswerValue
              maximumExpectedAnswerValue
              __typename
            }
            riskRule {
              alertOnMin
              alertOnMax
              __typename
            }
            __typename
          }
          choice {
            questionId
            questionHeader
            questionBody
            skipEnabled
            multipleChoice
            textChoices {
              textChoiceID
              textToDisplay
              __typename
            }
            branchingRule {
              defaultQuestionId
              destinationQuestionId
              expectedAnswerValues
              destinations {
                choiceId
                destinationQuestionId
                __typename
              }
              __typename
            }
            riskRule {
              alertOn
              __typename
            }
            __typename
          }
          textEntry {
            questionId
            questionHeader
            questionBody
            skipEnabled
            maxCharacterLengthForInput
            textHint
            __typename
          }
          bool {
            questionId
            questionHeader
            questionBody
            skipEnabled
            trueValue
            falseValue
            branchingRule {
              destinationQuestionId
              defaultQuestionId
              expectedAnswer
              __typename
            }
            riskRule {
              alertOn
              __typename
            }
            __typename
          }
          timeOfDay {
            questionId
            questionHeader
            questionBody
            skipEnabled
            defaultHour
            defaultMinute
            branchingRule {
              destinationQuestionId
              defaultQuestionId
              minimumExpectedAnswerHour
              minimumExpectedAnswerMinute
              maximumExpectedAnswerHour
              maximumExpectedAnswerMinute
              __typename
            }
            __typename
          }
          info {
            questionId
            questionHeader
            questionBody
            skipEnabled
            __typename
          }
          __typename
        }
        containsBranchingLogic
        containsShuffledSequence
        containsRiskAlerts
        shuffleSequence {
          startIndex
          endIndex
          __typename
        }
        multipleSurveyBursts
        daysWithinSurveyBurst
        daysBetweenSurveyBursts
        daysBeforeFirstSurveyDelivery
        selfInitiatedSurvey
        weekDeliverySchedule {
          dayOfWeek
          windowStartHour
          windowEndHour
          repeatsEveryDay
          __typename
        }
        __typename
      }
      exact {
        surveyId
        notificationHeader
        notificationBody
        weekdaysAvailable
        totalNumberOfDays
        introStepHeader
        introStepBody
        completionStepEnabled
        completionStepHeader
        completionStepBody
        emaQuestions {
          scale {
            questionId
            questionHeader
            questionBody
            skipEnabled
            minValue
            maxValue
            minimumValueDescription
            maximumValueDescription
            shouldHideRanges
            branchingRule {
              destinationQuestionId
              defaultQuestionId
              minimumExpectedAnswerValue
              maximumExpectedAnswerValue
              __typename
            }
            riskRule {
              alertOnMin
              alertOnMax
              __typename
            }
            __typename
          }
          choice {
            questionId
            questionHeader
            questionBody
            skipEnabled
            multipleChoice
            textChoices {
              textChoiceID
              textToDisplay
              __typename
            }
            branchingRule {
              defaultQuestionId
              destinationQuestionId
              expectedAnswerValues
              destinations {
                choiceId
                destinationQuestionId
                __typename
              }
              __typename
            }
            riskRule {
              alertOn
              __typename
            }
            __typename
          }
          textEntry {
            questionId
            questionHeader
            questionBody
            skipEnabled
            maxCharacterLengthForInput
            textHint
            __typename
          }
          bool {
            questionId
            questionHeader
            questionBody
            skipEnabled
            trueValue
            falseValue
            branchingRule {
              destinationQuestionId
              defaultQuestionId
              expectedAnswer
              __typename
            }
            riskRule {
              alertOn
              __typename
            }
            __typename
          }
          timeOfDay {
            questionId
            questionHeader
            questionBody
            skipEnabled
            defaultHour
            defaultMinute
            branchingRule {
              destinationQuestionId
              defaultQuestionId
              minimumExpectedAnswerHour
              minimumExpectedAnswerMinute
              maximumExpectedAnswerHour
              maximumExpectedAnswerMinute
              __typename
            }
            __typename
          }
          info {
            questionId
            questionHeader
            questionBody
            skipEnabled
            __typename
          }
          __typename
        }
        containsBranchingLogic
        containsShuffledSequence
        containsRiskAlerts
        shuffleSequence {
          startIndex
          endIndex
          __typename
        }
        multipleSurveyBursts
        daysWithinSurveyBurst
        daysBetweenSurveyBursts
        daysBeforeFirstSurveyDelivery
        selfInitiatedSurvey
        weekDeliverySchedule {
          dayOfWeek
          exactDeliveriesForDay {
            surveyDeliveryHour
            surveyDeliveryMinute
            surveyExpirationHour
            surveyExpirationMinute
            repeatsEveryDay
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    maxScreenTimePages
    selfInitiatedSurveyEnabled
    selfInitiatedSurveyTitle
    screenTimeConfig {
      alldays {
        blockId
        start
        end
        __typename
      }
      monday {
        blockId
        start
        end
        __typename
      }
      tuesday {
        blockId
        start
        end
        __typename
      }
      wednesday {
        blockId
        start
        end
        __typename
      }
      thursday {
        blockId
        start
        end
        __typename
      }
      friday {
        blockId
        start
        end
        __typename
      }
      saturday {
        blockId
        start
        end
        __typename
      }
      sunday {
        blockId
        start
        end
        __typename
      }
      __typename
    }
    _version
    _deleted
    _lastChangedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSurveyPrefsMutationVariables,
  APITypes.DeleteSurveyPrefsMutation
>;
